module.exports = __webpack_public_path__ + "static/media/2.4991642a.png";